// CMS helper functions to fetch content from the public API

const API_BASE = 'https://api.dev.auxo.dk/public';

// Fallback data in case the CMS is unreachable or empty
const FALLBACK_GALLERY = [
  {
    id: "1",
    title: "Komplet tagrenovering i Fredericia",
    description: "Nyt, flot tag i klassiske røde teglsten på et smukt parcelhus. Alt træværk og isolering er opdateret til moderne standarder.",
    image: ["https://assets.auxodev.dk/assets/cf131c5c-877c-4f32-8100-a69e4d795732/danish-roof-work.jpg"],
    category: "Tagarbejde",
    slug: { da: "komplet-tagrenovering-i-fredericia" }
  },
  {
    id: "2",
    title: "Eksklusiv træterrasse i lærk",
    description: "Opbygning af en stor, moderne træterrasse i højeste kvalitet med integrerede trapper og smukke detaljer.",
    image: ["https://assets.auxodev.dk/assets/cf131c5c-877c-4f32-8100-a69e4d795732/danish-wooden-terrace.jpg"],
    category: "Træterrasser",
    slug: { da: "eksklusiv-traeterrasse-i-laerk" }
  },
  {
    id: "3",
    title: "Udskiftning af døre og vinduer",
    description: "Montering af energirigtige træ-alu vinduer og døre på klassisk dansk murstensvilla. Giver bedre indeklima og lavere varmeregning.",
    image: ["https://assets.auxodev.dk/assets/cf131c5c-877c-4f32-8100-a69e4d795732/danish-windows-installation.jpg"],
    category: "Vinduer & Døre",
    slug: { da: "udskiftning-af-doere-og-vinduer" }
  },
  {
    id: "4",
    title: "Totalrenovering af parcelhus",
    description: "Gennemgribende renovering af 70'er parcelhus, herunder facadeisolering, nye lofter, gulve og modernisering af rumfordeling.",
    image: ["https://assets.auxodev.dk/assets/cf131c5c-877c-4f32-8100-a69e4d795732/danish-house-renovation.jpg"],
    category: "Renovering",
    slug: { da: "totalrenovering-af-parcelhus" }
  },
  {
    id: "5",
    title: "Facaderenovering & pudsearbejde",
    description: "Professionel facaderenovering med netpuds og maling. Huset fremstår nu fuldstændig moderne, lyst og modstandsdygtigt overfor vind og vejr.",
    image: ["https://assets.auxodev.dk/assets/cf131c5c-877c-4f32-8100-a69e4d795732/danish-facade-insulation.jpg"],
    category: "Facadearbejde",
    slug: { da: "facaderenovering-pudsearbejde" }
  }
];

const FALLBACK_REVIEWS = [
  {
    id: "1",
    name: "Morten Schmidt",
    location: "Fredericia",
    review: "K. Pheiffer Construction har lavet vores nye tag, og vi kunne ikke være mere tilfredse. Super professionelt arbejde, overholdt alle aftaler og ryddede pænt op efter sig. Kan varmt anbefales!",
    rating: 5
  },
  {
    id: "2",
    name: "Signe & Thomas",
    location: "Middelfart",
    review: "Vi fik bygget en fantastisk træterrasse i lærk. Håndværket er helt i top, og detaljerne er virkelig gennemtænkte. K. Pheiffer er ærlig, pålidelig og leverer varen.",
    rating: 5
  },
  {
    id: "3",
    name: "Jens Peter Hansen",
    location: "Vejle",
    review: "Fik udskiftet alle vinduer og døre i huset. Arbejdet blev udført hurtigt, præcist og til den aftalte pris. Rigtig god kommunikation hele vejen igennem.",
    rating: 5
  },
  {
    id: "4",
    name: "Camilla Nielsen",
    location: "Kolding",
    review: "Yderst professionel facaderenovering. Vores hus har fået et helt nyt liv, og arbejdet er udført med stor sans for detaljen. En tømrer man kan stole på!",
    rating: 5
  },
  {
    id: "5",
    name: "Henrik Poulsen",
    location: "Erritsø",
    review: "Altid god service og fantastisk kvalitet. K. Pheiffer Construction hjalp os med en større renovering, og resultatet er blevet helt perfekt. 5 stjerner herfra!",
    rating: 5
  }
];

export async function fetchGallery() {
  try {
    const response = await fetch(`${API_BASE}/content/gallery`);
    if (!response.ok) throw new Error('Failed to fetch gallery');
    const data = await response.json();
    return data && data.length > 0 ? data : FALLBACK_GALLERY;
  } catch (error) {
    console.warn('CMS fetch error, using fallback gallery:', error);
    return FALLBACK_GALLERY;
  }
}

export async function fetchReviews() {
  try {
    const response = await fetch(`${API_BASE}/content/reviews`);
    if (!response.ok) throw new Error('Failed to fetch reviews');
    const data = await response.json();
    return data && data.length > 0 ? data : FALLBACK_REVIEWS;
  } catch (error) {
    console.warn('CMS fetch error, using fallback reviews:', error);
    return FALLBACK_REVIEWS;
  }
}
